import React from 'react'

import { array } from 'prop-types'

import AssetItem from 'Pods/UnifiedNavigation/Shared/AssetItem/AssetItem'

function TypeList({ items }) {
  if (!items?.length) {
    return null
  }

  const filteredItems = items.filter((item) => item.icon !== 'printable')

  return (
    <div className="type-list">
      {filteredItems.map((type) => (
        <AssetItem
          key={type.name}
          title={type.name}
          icon={type.icon}
          href={type.path}
          showArrow={false}
        />
      ))}
    </div>
  )
}

TypeList.propTypes = {
  items: array.isRequired,
}

export default TypeList
